import { render, staticRenderFns } from "./open-member-top.vue?vue&type=template&id=6e83256e&scoped=true&lang=pug&"
import script from "./open-member-top.vue?vue&type=script&lang=js&"
export * from "./open-member-top.vue?vue&type=script&lang=js&"
import style0 from "./open-member-top.vue?vue&type=style&index=0&id=6e83256e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e83256e",
  null
  
)

export default component.exports